import { LfsPointerError, type ResourceError } from "@core-ui/ContextServices/ResourceService/errors";
import { cn } from "@core-ui/utils/cn";
import t from "@ext/localization/locale/translate";
import { Icon } from "@ui-kit/Icon";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";

export interface InlineImageErrorProps {
	width: string;
	height: string;
	resourceError?: ResourceError;
}

const getErrorData = (resourceError: ResourceError) => {
	if (resourceError instanceof LfsPointerError) {
		return {
			icon: "cloud-alert",
			tooltip: t("git.lfs.file-is-pointer"),
			containerClassName: "border-primary-border bg-primary-bg",
		};
	}

	return {
		icon: "image-off",
		tooltip: t("alert.image.unavailable"),
		containerClassName: "border-status-error-secondary-border bg-status-error-bg",
	};
};

const InlineImageError = ({ width, height, resourceError }: InlineImageErrorProps) => {
	const { icon, tooltip, containerClassName } = getErrorData(resourceError);

	return (
		<Tooltip>
			<TooltipTrigger>
				<div
					className={cn(
						"flex cursor-default items-center justify-center rounded-[var(--radius-small)] border",
						containerClassName,
					)}
					data-focusable="true"
					style={{ width, height }}
				>
					<Icon className="text-secondary-fg [stroke-width:1.25]" icon={icon} size="lg" />
				</div>
			</TooltipTrigger>
			<TooltipContent>{tooltip}</TooltipContent>
		</Tooltip>
	);
};

export default InlineImageError;
